import { Link, useNavigate } from "react-router-dom";
import { Menu, X, User } from "lucide-react";
import { useState } from "react";
import { useCustomerAuth } from "@/context/CustomerAuthContext";

export default function PublicNav({ topClass = "top-0" }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { customer, startLogin } = useCustomerAuth();
  const links = [
    { label: "Home", to: "/" },
    { label: "Park Schedule", to: "/schedule" },
    { label: "Session Packs", to: "/bundles" },
    { label: "Approach", to: "/#approach" },
  ];
  return (
    <header className={`fixed ${topClass} inset-x-0 z-50 bg-white/75 backdrop-blur-xl border-b border-brand-line`} data-testid="public-nav">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex flex-col leading-none" data-testid="nav-logo">
          <span className="font-display text-xl sm:text-2xl tracking-[0.15em] text-brand-ink">PAWS <span className="text-brand-red">N</span> POSES</span>
          <span className="text-[10px] tracking-[0.4em] text-brand-ink/60 mt-1 uppercase">Salt Lake City · Utah</span>
        </Link>
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link key={l.label} to={l.to} className="text-sm tracking-wide text-brand-ink/80 hover:text-brand-red transition-colors" data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g,'-')}`}>
              {l.label}
            </Link>
          ))}
          <Link to="/book" className="px-6 py-2.5 rounded-full bg-brand-red text-white text-sm font-medium hover:bg-brand-reddark transition-colors" data-testid="nav-book-btn">
            Book a Session
          </Link>
          {customer ? (
            <Link to="/account" className="inline-flex items-center gap-1.5 text-sm text-brand-ink/80 hover:text-brand-red transition-colors" data-testid="nav-account-link"><User className="w-4 h-4" /> My Account</Link>
          ) : (
            <button onClick={startLogin} className="text-sm text-brand-ink/80 hover:text-brand-red transition-colors" data-testid="nav-signin-btn">Sign in</button>
          )}
          <Link to="/login" className="text-sm text-brand-ink/50 hover:text-brand-ink transition-colors" data-testid="nav-login-link">Owner Login</Link>
        </nav>
        <button className="md:hidden text-brand-ink" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-white border-t border-brand-line px-6 py-6 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <Link key={l.label} to={l.to} onClick={() => setOpen(false)} className="text-brand-ink/80">{l.label}</Link>
          ))}
          <button onClick={() => { setOpen(false); navigate("/book"); }} className="px-6 py-3 rounded-full bg-brand-red text-white text-sm">Book a Session</button>
          {customer ? (
            <Link to="/account" onClick={() => setOpen(false)} className="text-sm text-brand-ink/80" data-testid="nav-account-link-mobile">My Account</Link>
          ) : (
            <button onClick={() => { setOpen(false); startLogin(); }} className="text-sm text-brand-ink/80 text-left" data-testid="nav-signin-btn-mobile">Sign in</button>
          )}
          <Link to="/login" onClick={() => setOpen(false)} className="text-sm text-brand-ink/50">Owner Login</Link>
        </div>
      )}
    </header>
  );
}
